// NOTE: These paths are risky since they overlap with the
// schema of PROJECT_BASE_PATH. It would be nice to always
// mediate variable route components with a static path. For
// example: `/:entityName/project/:projectName` instead of
// `/:entityName/:projectName`.

import {envIsPublicCloud} from '../../config';

// Team-level registry paths
export const TEAM_REGISTRY_LANDING_PATH = '/teams/registry/';
export const TEAM_REGISTRY_DETAILS_PATH = '/teams/registry/:registryName?';
export const ENTITY_REGISTRY_ALL_TEAMS_PATHS = [
  TEAM_REGISTRY_LANDING_PATH,
  TEAM_REGISTRY_DETAILS_PATH,
];
export const ENTITY_REGISTRY_ACCESS_CONTROL_PATH =
  '/:entityName/registry/:registryName/access-control';
export const ENTITY_REGISTRY_LANDING_PATH = '/:entityName/registry/';
export const ENTITY_REGISTRY_DETAILS_PATH =
  '/:entityName/registry/:registryName?';
export const ENTITY_REGISTRY_PATHS = [
  ...ENTITY_REGISTRY_ALL_TEAMS_PATHS,
  ENTITY_REGISTRY_LANDING_PATH,
  ENTITY_REGISTRY_DETAILS_PATH,
  ENTITY_REGISTRY_ACCESS_CONTROL_PATH,
];

// Organization registry paths
// Deprecated registry paths that redirect to /orgs/:orgName/registry/:registryName now
export const OLD_ORG_REGISTRY_SETTINGS_PATH =
  '/registry/:registryName/settings';
export const OLD_REGISTRY_LANDING_PATH = '/registry/';
export const OLD_REGISTRY_DETAILS_PATH = '/registry/:registryName?';
export const OLD_ENTITY_REGISTRY_ALL_TEAMS_PATHS = [
  OLD_REGISTRY_LANDING_PATH,
  OLD_REGISTRY_DETAILS_PATH,
  OLD_ORG_REGISTRY_SETTINGS_PATH,
];

export const ORG_SCOPED_REGISTRY_LANDING_PATH = envIsPublicCloud
  ? '/orgs/:orgName/registry/'
  : '/orgs/server/registry/';
export const ORG_SCOPED_REGISTRY_DETAILS_PATH = envIsPublicCloud
  ? '/orgs/:orgName/registry/:registryName?'
  : '/orgs/server/registry/:registryName?';
export const ORG_SCOPED_REGISTRY_SETTINGS_PATH = envIsPublicCloud
  ? '/orgs/:orgName/registry/:registryName/settings'
  : '/orgs/server/registry/:registryName/settings';

export const ORG_SCOPED_REGISTRY_PATHS = [
  ORG_SCOPED_REGISTRY_LANDING_PATH,
  ORG_SCOPED_REGISTRY_DETAILS_PATH,
];

export const ORG_REGISTRY_PATHS = [
  ...OLD_ENTITY_REGISTRY_ALL_TEAMS_PATHS,
  ...ORG_SCOPED_REGISTRY_PATHS,
  ORG_SCOPED_REGISTRY_SETTINGS_PATH,
];

export const REGISTRY_PATHS = [...ENTITY_REGISTRY_PATHS, ...ORG_REGISTRY_PATHS];
